export const tableSettings = {
  searchFields: [
    { label: 'Auction Name', param: 'auction', inputWidth: '400px' },
  ],
  pageSelectTitle: 'Auctions',
  initialSortColumn: 'auctionState',
  initialSortDirection: 'desc',
  standardStoreParams: [
    'searchText',
    'pageNumber',
    'pageSize',
    'sortColumn',
    'sortDirection',
    'auctionState',
  ],
  getMethods: (auction) => {
    return {
      name: 'auctionState',
      fn: auction.fn,
      args: [...tableSettings.standardStoreParams, 'auctionState'],
      dataToMerge: { auctionState: auction.state },
    };
  },
};

const headerSchema = [
  {
    index: 11,
    value: '',
    text: 'Transcript',
    sort: false,
  },
  { index: 1, value: 'auction', text: 'Name', sort: true },
  {
    index: 2,
    value: 'auctionState',
    text: 'Status',
    sort: true,
    initialSort: true,
  },
  { index: 3, value: 'numberOfImages', text: 'Images', sort: true },
  { index: 4, value: 'numberOfLanes', text: 'Lanes', sort: true },
  { index: 5, value: 'numberOfProducts', text: 'Products', sort: true },
  { index: 6, value: 'numberOfProxyBids', text: 'Proxy Bids', sort: true },
  {
    index: 7,
    value: 'numberOfRegisteredBidders',
    text: 'Registered Bidders',
    sort: true,
  },
  {
    index: 8,
    value: 'numberOfRegisteredSellers',
    text: 'Registered Sellers',
    sort: true,
  },
  { index: 9, value: 'startTime', text: 'Start Date', sort: true },
  { index: 10, value: 'endTime', text: 'End Date', sort: true },
];

const bodySchema = [
  {
    index: 11,
    value: ['auctionID'],
    content: {
      type: 'buttons',
      value: [
        {
          text: 'View Transcript',
          url: ['auction', '[auctionID]', 'auctionTranscriptReport'],
          key: '[auctionID]',
        },
      ],
    },
    style: {
      width: '150px',
    },
  },
  {
    index: 1,
    value: 'auction',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 2,
    value: 'auctionState',
    content: { type: 'text', value: 'value' },
  },
  {
    index: 3,
    value: 'numberOfImages',
    content: {
      type: 'buttons',
      value: [
        {
          text: '[numberOfImages]',
          icon: 'images outline',
          color: 'orange',
          size: 'small',
          basic: true,
          url: ['auction', '[auctionID]', 'productImages'],
          state: { auctionName: '[auction]' },
          key: '[auctionID]',
        },
      ],
    },
  },
  {
    index: 4,
    value: 'numberOfLanes',
    content: {
      type: 'buttons',
      value: [
        {
          text: '[numberOfLanes]',
          icon: 'road',
          color: 'black',
          size: 'small',
          basic: true,
          url: ['auction', '[auctionID]', 'lanes'],
          state: { auctionName: '[auction]' },
          key: '[auctionID]',
        },
      ],
    },
  },
  {
    index: 5,
    value: 'numberOfProducts',
    content: {
      type: 'buttons',
      value: [
        {
          text: '[numberOfProducts]',
          icon: 'motorcycle',
          basic: true,
          url: ['auction', '[auctionID]', 'products'],
          state: { auctionName: '[auction]' },
          key: '[auctionID]',
        },
      ],
    },
  },
  {
    index: 6,
    value: 'numberOfProxyBids',
    content: {
      type: 'buttons',
      value: [
        {
          text: '[numberOfProxyBids]',
          icon: 'gavel',
          color: 'green',
          basic: true,
          url: ['auction', '[auctionID]', 'proxyBids'],
          state: { auctionName: '[auction]' },
          key: '[auctionID]',
        },
      ],
    },
  },
  {
    index: 7,
    value: 'numberOfRegisteredBidders',
    content: {
      type: 'buttons',
      value: [
        {
          text: '[numberOfRegisteredBidders]',
          icon: 'user',
          color: 'teal',
          basic: true,
          url: ['auction', '[auctionID]', 'authorizedMembers'],
          state: { auctionName: '[auction]' },
          key: '[auctionID]',
        },
      ],
    },
  },
  {
    index: 8,
    value: 'numberOfRegisteredSellers',
    content: {
      type: 'buttons',
      value: [
        {
          text: '[numberOfRegisteredSellers]',
          icon: 'user outline',
          color: 'brown',
          basic: true,
          url: ['auction', '[auctionID]', 'authorizedMembers'],
          state: { auctionName: '[auction]' },
          key: '[auctionID]',
        },
      ],
    },
  },
  {
    index: 9,
    value: 'startTime',
    content: { type: 'datetime', value: 'value' },
    format: 'MM/DD/YYYY h:mm A',
  },
  {
    index: 10,
    value: 'endTime',
    content: { type: 'datetime', value: 'value' },
    format: 'MM/DD/YYYY h:mm A',
  },
];

export const schema = {
  tableSettings,
  headerSchema,
  bodySchema,
  debugging: false,
};
